import sodium from 'libsodium-wrappers'

export class Secure {
	private static instance: Secure
	public keyPair: Collection

	private constructor() {
		this.keyPair = {}
	}

	static getInstance(): Secure {
		if (!Secure.instance) {
			Secure.instance = new Secure()
		}

		return Secure.instance
	}

	async generateKeypair() {
		await sodium.ready

		this.keyPair = sodium.crypto_box_keypair()
		return this.keyPair
	}

	async parseKeys(requestKey: number[]): Promise<Collection> {
		await sodium.ready

		const publicKey = requestKey.slice(0, sodium.crypto_box_PUBLICKEYBYTES)
		const signKey = requestKey.slice(sodium.crypto_box_PUBLICKEYBYTES, requestKey.length)

		const requestPublicKey = new Uint8Array(publicKey)
		const requestSignKey = new Uint8Array(signKey)

		return { requestPublicKey, requestSignKey }
	}

	async parseEncryptedString(data: string): Promise<Collection> {
		await sodium.ready

		const encryptedString = data.split('|')[0]
		const signedString = data.split('|')[1]

		const encrypted = sodium.from_hex(encryptedString)
		const signed = sodium.from_hex(signedString)

		const nonce = encrypted.slice(0, sodium.crypto_box_NONCEBYTES)
		const message = encrypted.slice(sodium.crypto_box_NONCEBYTES, encrypted.length)

		return { nonce, message, signed }
	}

	async parseNonce(data: string): Promise<Collection> {
		await sodium.ready

		const encrypted = sodium.from_hex(data)

		const nonce = encrypted.slice(0, sodium.crypto_box_NONCEBYTES)
		const message = encrypted.slice(sodium.crypto_box_NONCEBYTES, encrypted.length)

		return { nonce, message }
	}

	async decrypt(message: string | Uint8Array, signature: Uint8Array, nonce: Uint8Array, publicKey: Uint8Array, privateKey: Uint8Array, signKey: Uint8Array): Promise<string> {
		await sodium.ready

		let patientData: string = ''
		try {
			const decrypted = sodium.crypto_box_open_easy(message, nonce, publicKey, privateKey)
			let verified = false

			try {
				verified = await sodium.crypto_sign_verify_detached(signature, decrypted, signKey)
			} catch (error) {
				throw error
			}

			if (!verified) {
				throw new Error(`Can not verify signature`)
			}

			try {
				patientData = sodium.to_string(decrypted)
			} catch (error) {
				throw error
			}
		} catch (error) {
			throw error
		}

		return patientData
	}

	async decryptImage(message: string | Uint8Array, nonce: Uint8Array, publicKey: Uint8Array, privateKey: Uint8Array): Promise<string> {
		await sodium.ready

		let imgString: string = ''
		try {
			const decrypted = sodium.crypto_box_open_easy(message, nonce, publicKey, privateKey)
			imgString = sodium.to_string(decrypted)
		} catch (error) {
			throw error
		}


		return imgString
	}
}
